import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axiosInstance from '../../../axiosInstance';
import { useTranslation } from 'react-i18next';
import DeleteModal from '../../common/DeleteModal';
import DataTableComponent from '../../common/DataTable/PrimeDataTable';
import { convertUTCToLocal } from '../../utils/dateUtils';

const SubFormList = ({ persona }) => {
  const [resp] = useState('');
  const [t] = useTranslation();
  const [data, setData] = useState([]);
  const [confirmDeleteModal, setConfirmDeleteModal] = useState({
    open: false,
    record: null,
  });
  const [paginationParams, setPaginationParams] = useState({
    limit: 10,
    offset: 0,
    sortField: 'createdAt',
    sortOrder: -1,
  });
  const navigate = useNavigate();

  useEffect(() => {
    fetchSubForms();
  }, [paginationParams]);

  const fetchSubForms = async () => {
    const response = await axiosInstance
      // eslint-disable-next-line no-undef
      .get(`${process.env.REACT_APP_SERVER_URL}/api/subforms`, {
        withCredentials: true,
      })
      .catch((err) => {
        console.log(err);
      });

    setData(response?.data);
  };

  const onDataTableEvent = (event) => {
    setPaginationParams((prev) => ({
      ...prev,
      limit: event.rows,
      offset: event.first,
      sortField: event.sortField || prev.sortField,
      sortOrder: event.sortOrder || prev.sortOrder,
    }));
  };

  const columns = [
    { field: 'id', header: 'ID', sortable: true },
    { field: 'name', header: t('name'), sortable: true, filter: true },
    {
      field: 'createdBy',
      header: t('createdBy'),
      sortable: true,
      filter: true,
      body: (rowData) => rowData.User?.username,
    },
    {
      field: 'createdAt',
      header: t('createdAt'),
      sortable: true,
      filter: true,
      body: (rowData) => convertUTCToLocal(rowData.createdAt),
    },
  ];

  const actions = [
    {
      text: t('view'),
      color: 'primary',
      onClick: (row) => navigate(`/${persona}/subforms/details/${row.id}`),
    },
    {
      text: t('edit'),
      color: 'secondary',
      onClick: (row) => navigate(`/${persona}/subforms/edit/${row.id}`),
    },
    // { text: "Delete", onClick: (row) => setConfirmDeleteModal({ open: true, record: row }), color: "primary", status: 'danger' },
  ];

  return (
    <div>
      {resp && <p>{resp}</p>}

      <DataTableComponent
        data={data}
        columns={columns}
        actions={actions}
        totalRecords={data?.length}
        enableCreate={true}
        paginationParams={paginationParams}
        onDataTableEvent={onDataTableEvent}
        enablePagination={true}
        enableLazyLoading={false}
      />

      {confirmDeleteModal && (
        <DeleteModal
          sentData={confirmDeleteModal.record}
          onEvent={setConfirmDeleteModal}
          onConfirm={fetchSubForms}
          apiPath="subforms"
          axios={axiosInstance}
          columnName="name"
        />
      )}
    </div>
  );
};

export default SubFormList;
